export enum StatusInvoice{
    ContainsErrors = -9,
    ToProcess = -2,
    ToSend = -1,
    InProcess = 0,
    Sent = 1,
}